export const PlusIcon = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M12 8V16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M16 12H8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    );
};